import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import ReactDOM from "react-dom"
import Radium from "higher-order-components/configured-radium/"
import { rafThrottle } from "utils"
import { H6 } from 'AtomicComponents'

/** Renders a stat list. */
export class StatList extends PureComponent {
  constructor() {
    super()
    this.state = {
      active: false
    }
    this.items = []
  }
  componentDidMount() {
    this.container = ReactDOM.findDOMNode(this)
    this.scrollEvent = rafThrottle(this.calculateLines)
    window.addEventListener("resize", this.scrollEvent)
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.scrollEvent)
  }

  render() {
    const { stats } = this.props
    return (
      <ul style={[styles.statlist]} data-test="stat-list">
        {!!stats &&
          stats.map((stat, index) => {
            const { uppercase, value, description } = stat
            return (
              <li ref={item => (this.items[index] = item)} key={index} style={styles.statDefault}>
                {value && <span style={[styles.value, { marginTop: "auto" }]}>{value}</span>}
                <H6
                  withDetails
                  style={[
                    styles.description,
                    (typeof uppercase === "undefined" ? true : uppercase) && {
                      textTransform: "uppercase"
                    },
                    !value && { marginTop: "auto" }
                  ]}>
                  {description}
                </H6>
              </li>
            )
          })}
      </ul>
    )
  }
}

StatList.propTypes = {
  stats: PropTypes.arrayOf(PropTypes.shape({
    uppercase: PropTypes.bool,
    value: PropTypes.string,
    description: PropTypes.string.isRequired
  })).isRequired
}

export default Radium(StatList)

const styles = {
  statlist: {
    margin: "0 auto",
    padding: 0,
    flex: "1 1 auto",
    flexWrap: "wrap",
    listStyleType: "none",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    position: "relative",
    fontWeight: 200,
    top: "-2px",
    left: "-2px",
    whiteSpace: "normal"
  },
  statDefault: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    padding: "1em",
    margin: "0",
    flex: "1 1 auto",
    minWidth: "13em",
    boxSizing: "border-box",
    borderStyle: "solid",
    borderColor: "#999",
    borderWidth: "0 1px 1px 0",
    top: "2px",
    left: "2px"
  },
  value: {
    display: "block",
    fontSize: "270%",
    letterSpacing: "-0.03em",
    lineHeight: 1
  },
  description: {
    display: "block",
    fontSize: "90%",
    fontWeight: "600",
    letterSpacing: ".2em",
    lineHeight: 1.4
  },
  divider: {
    position: "absolute",
    height: "100%",
    top: "0",
    right: "0",
    transform: "rotate(25deg)",
    width: "1px",
    display: "inline-block",
    backgroundColor: "#999"
  }
}



// WEBPACK FOOTER //
// ./src/containers/stat-list/index.jsx